import React from 'react'

import {
    MovableCardWrapper,
    CardHeader,
    CardRightContent,
    CardTitle,
    Detail,
    Footer,
} from 'react-trello/dist/styles/Base'

import Tag from 'react-trello/dist/components/Card/Tag'
import styled from 'styled-components'
import { Icon } from './Icon'

type Props = {
    showDeleteButton: boolean
    onDelete: () => void
    onClick: () => void
    style: any
    tagStyle: any
    className: string
    id: string
    title: string
    label: string
    description: string
    tags: Array<[]>
    cardDraggable: boolean
    editable: boolean
    childCards: Array<[]>
    isNewMessage: boolean
}

export const Card = (props: Props): JSX.Element => {
    const {
        id,
        showDeleteButton,
        onDelete,
        onClick,
        style,
        tagStyle,
        title,
        description,
        label,
        tags,
        className,
        cardDraggable,
        editable,
        childCards,
        isNewMessage,
    } = props

    return (
        <MovableCardWrapper data-id={id} onClick={onClick} style={style} className={className}>
            <CardHeader>
                <CardTitle draggable={cardDraggable}>{title}</CardTitle>
                <CardRightContent>
                    {label}{' '}
                    {isNewMessage && (
                        <IconContainer>
                            <Icon size={3} iconKey="MailOutlined" color="danger" />
                        </IconContainer>
                    )}
                </CardRightContent>
            </CardHeader>
            <Detail>{description}</Detail>
            {tags && tags.length > 0 && (
                <Footer>
                    {tags.map((tag: any) => (
                        <Tag key={tag.title} {...tag} tagStyle={tagStyle} />
                    ))}
                </Footer>
            )}
            {childCards && childCards.length > 0 && (
                <div>
                    {childCards.map((card: any) => (
                        <Container key={`child-container-${card.id}`}>
                            <CardHeader>
                                <CardTitle />
                                <CardRightContent>{card.label}</CardRightContent>
                            </CardHeader>
                            <Detail>{card.description}</Detail>
                            {card.tags && card.tags.length > 0 && (
                                <Footer>
                                    {card.tags.map((tag) => (
                                        <Tag key={tag.title} {...tag} tagStyle={tagStyle} />
                                    ))}
                                </Footer>
                            )}
                        </Container>
                    ))}
                </div>
            )}
        </MovableCardWrapper>
    )
}

const Container = styled.div`
    margin-top: 10px;
`

const IconContainer = styled.div`
    float: right;
    margin-left: 5px;
`
